import React, { ReactElement } from "react";
import Layout from '../../components/layout';
import GlobalProductList from "../../components/GlobalProducts";

const GlobalProductsPage = (): ReactElement => {
  return (
    <Layout>
      <GlobalProductList />
    </Layout>
  );
};

export default GlobalProductsPage;
